/**
 * External dependencies
 */
export default class ConnectionSalesTypes {
    constructor(id, cscom) {
        if (!(this instanceof ConnectionSalesTypes)) {
            return new ConnectionSalesTypes(id, cscom);
        }
        this.cscom = cscom;
        this.id = id;

        if (this.id) {
            this.path = `/user-site-api/user-connection-sales-types/${this.id}`;
        } else {
            this.path = `/user-site-api/user-connection-sales-types`;
        }
    }

    getConnectionSalesTypes() {
        return this.cscom.req.get(this.path);
    }

    update(body) {
        return this.cscom.req.put(this.path, body).then((result) => {
            return result;
        });
    }

    add(body) {
        return this.cscom.req.post(this.path, body).then((result) => {
            return result;
        });
    }

    remove() {
        return this.cscom.req.del(this.path).then((result) => {
            return result;
        });
    }
}
